import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { NothingFoundIcon } from 'static/icons';

export const NotFoundAlert: React.FC<{ text: string }> = ({ text }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="200px"
    >
      <NothingFoundIcon />
      <Text textStyle="h4" pt={6} pb={2}>
        {text}
      </Text>
      <Text textStyle="body2" color="asphalt.1">
        Попробуйте изменить запрос
      </Text>
    </Box>
  );
};
